import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    TextField,
    BooleanField,
    DateField,
    ReferenceField,
    Datagrid,
    EditButton,
    useGetList,
    Loading,
    ListContextProvider,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles({
    tab: {
        maxWidth: '100%',
    },
});

const DocumentsList = ({ record }: any) => {
    const { data, ids, loading, error, total } = useGetList(
        'user-documents',
        { page: 1, perPage: 100 },
        { field: 'createdAt', order: 'DESC' },
        { documentType: record?.name }
    );

    if (loading) return <Loading />;
    if (error)
        return <Typography color="error">Error loading documents</Typography>;
    if (!ids || ids.length === 0) {
        return (
            <Typography>No documents found for this document type.</Typography>
        );
    }

    return (
        <ListContextProvider
            value={{
                data,
                ids,
                loaded: true,
                loading: false,
                total: total || ids.length,
                page: 1,
                perPage: 100,
                currentSort: { field: 'createdAt', order: 'DESC' },
                basePath: '/user-documents',
                resource: 'user-documents',
                selectedIds: [],
            }}
        >
            <Datagrid rowClick="show">
                <TextField source="id" />
                <ReferenceField
                    source="userId"
                    reference="users"
                    link="show"
                    label="User"
                >
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="documentNumber" />
                <TextField source="fileName" label="File Name" />
                <DateField source="expiryDate" />
                <BooleanField source="isVerified" label="Verified" />
                <DateField source="createdAt" showTime />
            </Datagrid>
        </ListContextProvider>
    );
};

const DocumentTypeShow = (props: any) => {
    const classes = useStyles();

    return (
        <Show {...props}>
            <TabbedShowLayout>
                <Tab label="Summary" className={classes.tab}>
                    <TextField source="id" />
                    <TextField source="name" />
                    <TextField source="code" />
                    <TextField source="description" />
                    <BooleanField source="isActive" label="Active" />
                    <DateField source="createdat" label="Created at" showTime />
                    <DateField source="updatedat" label="Updated at" showTime />
                </Tab>

                <Tab label="Documents" path="documents" className={classes.tab}>
                    <DocumentsList />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

export default DocumentTypeShow;
